// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    DisplaySettingsIcon
}

const logs = {
    id: 'logs_audit',
    title: '',
    type: 'group',
    children: [
        {
            id: 'logs_audit_menu',
            title: 'Logs Auditoria',
            type: 'collapse',
            icon: icoMenu.DisplaySettingsIcon,
            children: [                
                {
                    id: 'lista_logs_audit',
                    title: 'Logs Eventos',
                    type: 'item',
                    url: '/user/list-logs-audit-view'
                },
            ]
        },
    ]
};

export default logs;
